import isEmpty from '../../../Shared/Utils/isEmpty';
import deriveMediaType from '../Util/deriveMediaType';
import mapManifestsToSchema from '../Util/mapManifestsToSchema';
import mapManifestsToRecommendedCdns from '../Util/mapManifestsToRecommendedCdns';

const subscribeToPlaybackApiResponse = (
    playbackApiResponse$,
    playbackStore,
    precisionStore,
) =>
    playbackApiResponse$
        .subscribe(({
            asset,
            media,
            playbackDetails,
            playbackPrecision,
        }) => {
            if (
                isEmpty(asset) ||
                isEmpty(media) ||
                isEmpty(playbackDetails)
            ) {
                return playbackStore.actions.disableFeature();
            }

            const manifestItems = playbackDetails;
            const [firstManifestItem] = manifestItems;
            const { isLinear, isLive } = asset;

            let manifests = mapManifestsToSchema(manifestItems);
            if (isEmpty(playbackPrecision)) {
                precisionStore.actions.disableFeature();
            } else {
                manifests = mapManifestsToRecommendedCdns(manifests, playbackPrecision.cdns);
            }

            playbackStore.actions.updatePlayback({
                asset,
                media,
                manifests,
                licenseUrl: firstManifestItem.laUrl,
                releasePid: firstManifestItem.releasePid,
                mediaType: deriveMediaType(isLinear, isLive),
                isEnabled: true,
            });
        });

export default subscribeToPlaybackApiResponse;
